import { createContext, useContext } from "react";
import { useParams } from "react-router";

/** Supplies the organisation to components rendered outside the `:organisationId` route, e.g. the notes drawer on the reports page */
export const OrganisationIdOverrideContext = createContext<string | undefined>(undefined);

/** The organisation ID from `OrganisationIdOverrideContext`, falling back to the route param */
export function useRouteOrganisationId() {
  const override = useContext(OrganisationIdOverrideContext);
  const { organisationId } = useParams<{ organisationId?: string }>();

  return {
    organisationId: override ?? organisationId,
    isOverridden: !!override,
  };
}
